import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        opener: '[js-service="opener"]',
        hiddenContent: '[js-service="hidden-content"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.opener)) {
            return
        }

        initServiceAccordions()
    }
    

    function initServiceAccordions() {
        if($(window).width() < 770){
            $(nodeSelectors.opener).on('click', function () {
                $(this).parent().toggleClass('active')
                let hiddenContent = $(this).parent().find(nodeSelectors.hiddenContent)
                hiddenContent.slideToggle()
            })
        }
    }

    return Object.freeze({
        init,
    })
}